const defaultLocale =
  typeof window !== 'undefined' ? window.navigator.language : 'en-GB';

export const getLocale = (locale?: string) => {
  if (locale && Intl.NumberFormat.supportedLocalesOf(locale).includes(locale)) {
    return locale;
  }

  return defaultLocale;
};
